@let isGroup = item().type === documentItemTypeEnum.GROUP_IMAGE;
<!-- Grupo segue o groupImageGrid; imagem única segue o singleImageGrid (tamanho da
     foto avulsa, padrão 1 = largura total) — mesma resolução item → documento do PDF.
     Antes a imagem única caía no groupImageGrid do documento, divergindo do PDF. -->
@let currentGrid = isGroup
    ? (item()?.configs?.groupImageGrid ?? config()?.groupImageGrid ?? 2)
    : singleSize().grid;
<!-- Imagem única reduzida (Média/Pequena): em vez de ocupar a 1ª coluna do grid,
     vira uma faixa cinza de ponta a ponta com a foto centralizada no tamanho do
     slot — mesmo tratamento do PDF (.single-centered em items/image.css). -->
<!-- Largura livre (arrastada no editor) vence o tamanho pronto, na mesma faixa. -->
@let customWidth = isGroup ? null : singleSize().width;
@let singleReduced = !isGroup && (customWidth !== null || currentGrid > 1);

<div
    class="container-images ra-grid gap-24"
    [class.grid-1]="customWidth === null && currentGrid === 1"
    [class.grid-2]="customWidth === null && currentGrid === 2"
    [class.grid-3]="customWidth === null && currentGrid === 3"
    [class.single-centered]="singleReduced"
    [class.custom-size]="customWidth !== null"
    [style.--image-width]="customWidth !== null ? customWidth + '%' : null">
    @for (image of listImages; track $index) {
        <div class="container-image">
            <!-- Frame só ao redor da imagem: a marca d'água fica restrita à foto,
                 sem cobrir o número/data que ficam abaixo.

                 O frame é um <button>: quem abre a tela cheia é a PRÓPRIA foto (com
                 teclado, inclusive). Antes existia um botão flutuante no canto do
                 grid — que, com 2/3 colunas, caía em cima da 2ª/3ª imagem. -->
            <button
                type="button"
                class="image-frame"
                [attr.aria-label]="'document.preview.imageData.expandLabel' | translate"
                (click)="imageOpen.emit($index)">
                <img
                    [src]="image.url"
                    (load)="onImageLoad($index, $event)"
                />

                <!-- Marca d'água: logo da company sobreposto, com a proporção da foto
                     para cobrir só a imagem (não o letterbox do card). -->
                @if (showWatermark()) {
                    <img
                        class="image-watermark"
                        [src]="companyLogo()"
                        [style.aspect-ratio]="imageAspects()[$index] || null"
                        aria-hidden="true"
                    />
                }

                <!-- Dica de zoom: só aparece onde existe hover (desktop). No toque não
                     há hover, e lá o clique direto na foto já é o gesto natural. -->
                <span class="image-zoom-hint" aria-hidden="true">
                    <ra-icon icon="maximize-3" varColor="currentColor" [size]="18" />
                </span>
            </button>

            <!-- Número da imagem -->
            @if (showImageNumber()) {
                <p class="ra-label-xs bold">{{ 'document.preview.imageData.numberLabel' | translate: { num: (image.numberImage | number:'3.0-0') } }}</p>
            }

            <!-- Data da imagem -->
            @if (showImageDate()) {

                <!-- Data da imagem -->
                <p class="ra-label-xs bold">{{ image.date | date:'shortDate' }}</p>
            }
        </div>
    }
</div>

@if (item()?.description)
{
    <p class="ra-label-s image-description" [style.--item-size]="descriptionSize()" [style.--item-color]="descriptionColor()">
        <ra-viewer-text [content]="item()?.description" />
    </p>
}
